import { ValueProvider } from '@juvare/common-form-ui/ValueProvider';
import { buildStorageValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { DepartmentColumns, departmentEntityName } from '../../../../backend/config/classifiers';

export function useDepartmentValueProvider(): ValueProvider {
    return buildStorageValueProvider<DepartmentColumns>({
        entityName: departmentEntityName,
        label: 'Department',
        classifierName: departmentEntityName,
        getValues: (client) =>
            client
                .list({
                    filter: [{ column: 'status', op: '=', value: 'active' }],
                    orderBy: [{ column: 'name' }],
                })
                .then((result) => result.rows.map((row) => ({ value: row.id, label: row.columns.name || '' }))),
    });
}
